import React from 'react';

export default function Cademi() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H19.2C23.6804 0 25.9206 0 27.6319 0.871948C29.1372 1.63893 30.3611 2.86278 31.1281 4.36808C32 6.07937 32 8.31958 32 12.8V19.2C32 23.6804 32 25.9206 31.1281 27.6319C30.3611 29.1372 29.1372 30.3611 27.6319 31.1281C25.9206 32 23.6804 32 19.2 32H12.8C8.31958 32 6.07937 32 4.36808 31.1281C2.86278 30.3611 1.63893 29.1372 0.871948 27.6319C0 25.9206 0 23.6804 0 19.2V12.8Z'
        fill='url(#paint0_linear_5187_43028)'
      />
      <path
        d='M6.0231 6.00369C8.81916 5.9749 11.3892 7.09316 13.4243 9.03463C16.1402 11.9835 16.1037 15.4687 16.1284 19.2688C16.1341 19.7153 16.1402 20.1618 16.1467 20.6083C16.1615 21.6921 16.1721 22.7758 16.1792 23.8596C16.2186 23.7235 16.258 23.5873 16.2987 23.447C16.3517 23.2667 16.4047 23.0864 16.4593 22.9006C16.5113 22.7226 16.5633 22.5445 16.6168 22.3611C17.3333 20.1475 19.1885 18.0365 21.2572 16.9607C21.6255 16.8027 21.9981 16.6547 22.3744 16.5169C22.5608 16.447 22.7473 16.3772 22.9393 16.3053C23.4914 16.1492 23.937 16.1192 24.5072 16.1491C24.5072 16.0152 24.5072 15.8813 24.5072 15.7433C24.3187 15.7266 24.1301 15.7098 23.9359 15.6926C21.6917 15.3536 19.8853 14.3566 18.4127 12.6275C16.9691 10.6684 15.9379 8.46223 15.9761 6.00369C18.7376 5.92811 20.9793 7.02088 23.0853 8.74295C24.7762 10.3784 25.9364 12.8057 25.9989 15.1489C26.0359 18.4646 25.1753 20.677 22.9822 23.197C22.1894 23.9682 21.2056 24.4393 20.2289 24.9376C20.0898 25.0087 19.9506 25.0797 19.8072 25.1529C17.7538 26.157 15.2461 26.2371 13.0689 25.559C10.0925 24.4151 7.95394 22.4709 6.63326 19.5581C6.16486 18.3828 5.99714 17.2586 6.00004 16.001C6.00005 15.7777 6.00007 15.5543 6.00008 15.3242C6.00113 15.0864 6.00218 14.8486 6.00326 14.6035C6.00355 14.3575 6.00384 14.1116 6.00413 13.8581C6.00527 13.0746 6.00781 12.2911 6.0104 11.5076C6.01142 10.9755 6.01235 10.4434 6.01318 9.91126C6.01541 8.60873 6.01881 7.30621 6.0231 6.00369Z'
        fill='url(#paint1_linear_5187_43028)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5187_43028'
          x1='-2.19528e-06'
          y1='32.6277'
          x2='31.8152'
          y2='-0.0334167'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#F8057E' />
          <stop offset='1' stop-color='#FA5A39' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_5187_43028'
          x1='5.84547'
          y1='1.89066'
          x2='20.364'
          y2='23.1713'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
      </defs>
    </svg>
  );
}
